import React from "react";
import PhoneNumberInput from "./PhoneNumberInput/PhoneNumberInput";
import styles from "./Style.module.css";

const Input = ({
  inputRef,
  label,
  subText,
  required = false,
  name = "",
  type = "text",
  value,
  onChange,
  error = "",
  warning = "",
  placeholder = "",
  wrapperClassName = "",
  labelClassName = "",
  className = "form-control",
  isPhone = false,
  defaultCountry = "SG",
  international = true,
  onCountryChange,
  disabled = false,
  readOnly = false,
  autoComplete,
}) => {
  const inputClassName = `${className} ${error ? "is-invalid" : ""}`.trim();

  return (
    <div className={wrapperClassName} ref={inputRef}>
      <label className={labelClassName} htmlFor={name || undefined}>
        {label}
        {required ? <span>*</span> : null}
      </label>

      {isPhone ? (
        <PhoneNumberInput
          id={name || undefined}
          name={name || undefined}
          placeholder={placeholder}
          defaultCountry={defaultCountry}
          international={international}
          value={value}
          onChange={onChange}
          onCountryChange={onCountryChange}
          className={inputClassName}
          disabled={disabled}
          readOnly={readOnly}
          autoComplete={autoComplete}
        />
      ) : (
        <input
          id={name || undefined}
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={inputClassName}
          required={required}
          disabled={disabled}
          readOnly={readOnly}
          autoComplete={autoComplete}
        />
      )}

      {error ? <div className="error-msg">{error}</div> : null}
      {!error && warning ? <div className="warning-msg">{warning}</div> : null}
      {subText ? <p className={styles.subText}>{subText}</p> : null}
    </div>
  );
};

export default Input;
